export default {
  scorecard: {
    title: 'Scorekarte',
    content: 'Inhalt',
    award: 'ESG-Auszeichnung',
  },
  list_table_filter: {
    table_buyer_company_name: 'Käufer',
    table_question_group_name: 'Umfrage',
    table_status: 'Status',
    table_issue_at: 'Datum der Ausgabe',
    table_sustaina_rate: 'ESG-Bewertung',
    table_esg_score: 'ESG-Punktzahl',
    table_operation: 'Operation',
    displayed_items_number: '{start} bis ${end} von ${total} Unternehmen anzeigen',
    displayed_items_number_empty: '0 von 0 Unternehmen anzeigen',
    no_data_display: 'Daten konnten nicht gefunden werden',
    csv_modal_title: 'Bitte wählen Sie die Elemente aus, die als CSV exportiert werden sollen',
    csv_modal_answer_status_title: 'Status der Antwort',
    csv_modal_answer_status_text: 'Exportieren Sie die Antwortstatusliste der Lieferanten.',
    csv_modal_answer_title: 'Antwort (1 Datei pro 500 Unternehmen)',
    csv_modal_answer_title_by_individual_company: 'Antwort (1Datei pro Unternehmen)',
    csv_modal_answer_text: 'Die Antworten der Lieferanten werden in 1 Datei pro 500 Unternehmen ausgegeben.',
    csv_modal_answer_text_by_individual_company: 'Die Antworten der Lieferanten werden in 1Datei pro 1Unternehmen ausgegeben.',
    csv_modal_score_title: 'Ergebnis',
    csv_modal_score_text: 'Exportieren Sie Bewertungen und Noten von Anbietern.',
    csv_modal_answer_heading: 'Kopfzeile',
    csv_modal_answer_heading_supplier: 'Lieferant',
    csv_modal_answer_heading_question: 'Frage',
    csv_modal_answer_additional: 'Zusätzliches Element',
    csv_modal_answer_additional_note: 'Anmerkungen',
    csv_modal_answer_additional_file: 'Name der angehängten Datei',
    csv_modal_cautionary_note_title: 'Hinweis',
    csv_modal_cautionary_note_content: '・Die Ausgabedatei enthält „Antwortstatus“, „Antwort“ und „Ergebnis“ für {questionGroupName}.\n・Für „Antwortstatus“ werden alle registrierten Unternehmen berücksichtigt, unabhängig von ihrem Antwortstatus in der Umfrage.\n・Für „Antwort“ und „Ergebnis“ werden Unternehmen mit dem Antwortstatus „In Bearbeitung“ nicht in die Ausgabedatei aufgenommen.\n・Die maximale Anzahl der Unternehmen, die in einer einzigen CSV-Datei für „Antwort“ und „Ergebnis“ angezeigt werden können, beträgt 1.000.\n・Die CSV-Datei wird an die E-Mail-Adresse des aktuell eingeloggten Kontos gesendet.',
    csv_modal_sent_mail_section_one: 'Ihre CSV-Exportanfrage wurde akzeptiert.',
    csv_modal_sent_mail_section_two: 'Bitte warten Sie einen Moment, bis eine E-Mail mit der URL zum Herunterladen der CSV-Datei an Ihre E-Mail-Adresse gesendet wird.',
    csv_modal_sent_mail_section_three: 'Wenn Sie innerhalb von 30 Minuten keine E-Mail erhalten, versuchen Sie es bitte erneut.',
  },
  overall_score_section: {
    card_title: 'Umfrage Inhalt',
    score: 'Ergebnis',
    esg_score: 'ESG-Punktzahl',
    esg_rating: 'ESG-Bewertung',
    esg_score_tip: 'Der ESG-Score ist eine Bewertung der ESG-Aktivitäten Ihres Unternehmens.Sie wird auf der Grundlage Ihrer Antworten auf die ASUENE ESG-Umfrage berechnet.',
    esg_rating_tip: 'Die ESG- Bewertung ist eine absolute Bewertung des Niveaus der ESG-Aktivitäten Ihres Unternehmens, die auf einer siebenstufigen Skala von AAA bis CCC auf der Grundlage Ihrer ESG-Punktzahl eingestuft wird.',
    evaluator_advice_title: 'Bewertung Kommentar',
    list_header_buyer_company_name: 'Käufer',
    list_header_supplier_company_name: 'Lieferant',
    list_header_question: 'Umfrage',
    list_header_create_at: 'Datum der Ausgabe',
    list_header_deadline: 'Datum des Verfalls',
    list_header_industry: 'Branche',
    list_header_company_scale: 'Anzahl der Mitarbeiter',
    list_header_status: 'Status',
    download_csv: 'CSV-Export',
    download_pdf: 'PDF-Export',
    // csv_title_for_buyer: "",
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Antworten im csv-Format herunterladen.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Antworten im pdf-Format herunterladen.',
    scorecard_pdf: 'Scorekarte(PDF)',
    download_scorecard_pdf_description: 'Punktestand im pdf-Format herunterladen.',
    feedback: 'Feedback zur Bewertung',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'Das Dokument wird im PDF-Format heruntergeladen.',
    award_medal_svg: 'ESG-Auszeichnung(SVG)',
    download_award_medal_svg_description: 'Als SVG-Bild herunterladen',
    award_medal_png: 'ESG-Auszeichnung(PNG)',
    download_award_medal_png_description: 'Als PNG-Bild herunterladen',
    pdf_modal_sent_mail_section_one: 'Ihre PDF-Exportanfrage wurde akzeptiert.',
    pdf_modal_sent_mail_section_two: 'Bitte warten Sie einen Moment, bis eine E-Mail mit der URL zum Herunterladen der PDF-Datei an Ihre E-Mail-Adresse gesendet wird.',
    pdf_modal_sent_mail_section_three: 'Wenn Sie innerhalb von 30 Minuten keine E-Mail erhalten, versuchen Sie es bitte erneut.',
  },
  category_score_section: {
    card_title: 'Punktzahl nach Kategorie',
    tip: 'Eine Kategoriebewertung ist eine Bewertung für die Umwelt-, Sozial- und Governance-Kategorie Ihres Unternehmens. Die Gewichtung der Fragen in jeder Kategorie ist je nach Unternehmen unterschiedlich.',
    policy: 'Richtlinie',
    action: 'Aktion',
    result: 'Ergebnis',
  },
  score_by_category_compared_section: {
    card_title: 'Vergleich der Punktzahlen nach Kategorie',
    get_score_by_category: 'Kategorie-Punktzahl Ihres Unternehmens',
    esg_evaluated_all_companies_average: 'Alle von Asene ESG bewerteten Unternehmen',
    tip: 'Dies ist die durchschnittliche Punktzahl der Unternehmen, die auf dieselbe Umfrage geantwortet haben.',
  },
  strengths_advice_section: {
    card_title: 'Stärke und Bereiche für Verbesserungen',
    strong_point: 'Stärke',
    advice: 'Bereiche für Verbesserungen',
    policies: 'Richtlinie',
    action: 'Aktion',
    result: 'Ergebnis',
    no_results_for_this_category: 'Für dieses Kategorie liegen keine Ergebnisse vor.',
    risk: 'Risiko',
    indicator: 'Indikator',
    content: 'Inhalt',
    operation: 'Operation',
  },
  preview: {
    go_back_to_scorecard: 'Zurück zur Scorecard',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Zusammenfassung der Gesamtbewertung',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Durchschnittliche Bewertung: ',
    category_card_score_no_score: 'Nicht zutreffend',
    category_card_score_earned_score: 'Ihr Ergebnis',
    category_card_details_list_title: 'Bewertung Kommentar',
    category_card_details_no_score_tip: 'Diese Kategorie ist nicht in der Bewertung enthalten.',
    category_card_score_average_score: 'Durchschnittliche Punktzahl aller Unternehmen',
    category_card_details_title: 'Zusammenfassung der Kategoriebewertung',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: 'Dieser Punkt ist nicht anwendbar, da die Umfrage nach der Logik des Käufers bewertet wird.',
    buyer_evaluate_tip: 'Dieser Punkt wird nach der Logik des Käufers bewertet. Es wird nicht nach der Bewertungslogik von Asuene ESG bewertet.',
    answer_rejection_notification: 'Sie haben einen neuen Antrag auf Rücknahme erhalten',
    answer_rejection_modal_title: 'Einreichung zurücksenden',
    answer_rejection_modal_text: 'Kommentar zurücksenden',
    answer_rejection_modal_content: 'Die Antwort von {companyName} wird zurückgeschickt. \nBitte schreiben Sie einen Kommentar für den Grund der Rücksendung',
    answer_rejection_dialog_content: "{companyName}'s Antwort wurde zurückgeschickt",
    answer_rejection_button_title: 'Zurücksenden',
  },
}
